/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as HistoryRouteRouteImport } from './routes/history/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OnboardingTermsRouteImport } from './routes/onboarding/terms'
import { Route as OnboardingStripeRouteImport } from './routes/onboarding/stripe'
import { Route as OnboardingMarketingRouteImport } from './routes/onboarding/marketing'
import { Route as OnboardingGpiRouteImport } from './routes/onboarding/gpi'
import { Route as HistoryPaymentsRouteImport } from './routes/history/payments'
import { Route as HistoryPatientsRouteImport } from './routes/history/patients'
import { Route as HistoryBulkRequestRouteImport } from './routes/history/bulk-request'

const HistoryRouteRoute = HistoryRouteRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingTermsRoute = OnboardingTermsRouteImport.update({
  id: '/onboarding/terms',
  path: '/onboarding/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingStripeRoute = OnboardingStripeRouteImport.update({
  id: '/onboarding/stripe',
  path: '/onboarding/stripe',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingMarketingRoute = OnboardingMarketingRouteImport.update({
  id: '/onboarding/marketing',
  path: '/onboarding/marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingGpiRoute = OnboardingGpiRouteImport.update({
  id: '/onboarding/gpi',
  path: '/onboarding/gpi',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryPaymentsRoute = HistoryPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => HistoryRouteRoute,
} as any)
const HistoryPatientsRoute = HistoryPatientsRouteImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => HistoryRouteRoute,
} as any)
const HistoryBulkRequestRoute = HistoryBulkRequestRouteImport.update({
  id: '/bulk-request',
  path: '/bulk-request',
  getParentRoute: () => HistoryRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/history': typeof HistoryRouteRouteWithChildren
  '/history/bulk-request': typeof HistoryBulkRequestRoute
  '/history/patients': typeof HistoryPatientsRoute
  '/history/payments': typeof HistoryPaymentsRoute
  '/onboarding/gpi': typeof OnboardingGpiRoute
  '/onboarding/marketing': typeof OnboardingMarketingRoute
  '/onboarding/stripe': typeof OnboardingStripeRoute
  '/onboarding/terms': typeof OnboardingTermsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/history': typeof HistoryRouteRouteWithChildren
  '/history/bulk-request': typeof HistoryBulkRequestRoute
  '/history/patients': typeof HistoryPatientsRoute
  '/history/payments': typeof HistoryPaymentsRoute
  '/onboarding/gpi': typeof OnboardingGpiRoute
  '/onboarding/marketing': typeof OnboardingMarketingRoute
  '/onboarding/stripe': typeof OnboardingStripeRoute
  '/onboarding/terms': typeof OnboardingTermsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/history': typeof HistoryRouteRouteWithChildren
  '/history/bulk-request': typeof HistoryBulkRequestRoute
  '/history/patients': typeof HistoryPatientsRoute
  '/history/payments': typeof HistoryPaymentsRoute
  '/onboarding/gpi': typeof OnboardingGpiRoute
  '/onboarding/marketing': typeof OnboardingMarketingRoute
  '/onboarding/stripe': typeof OnboardingStripeRoute
  '/onboarding/terms': typeof OnboardingTermsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/history'
    | '/history/bulk-request'
    | '/history/patients'
    | '/history/payments'
    | '/onboarding/gpi'
    | '/onboarding/marketing'
    | '/onboarding/stripe'
    | '/onboarding/terms'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/history'
    | '/history/bulk-request'
    | '/history/patients'
    | '/history/payments'
    | '/onboarding/gpi'
    | '/onboarding/marketing'
    | '/onboarding/stripe'
    | '/onboarding/terms'
  id:
    | '__root__'
    | '/'
    | '/history'
    | '/history/bulk-request'
    | '/history/patients'
    | '/history/payments'
    | '/onboarding/gpi'
    | '/onboarding/marketing'
    | '/onboarding/stripe'
    | '/onboarding/terms'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HistoryRouteRoute: typeof HistoryRouteRouteWithChildren
  OnboardingGpiRoute: typeof OnboardingGpiRoute
  OnboardingMarketingRoute: typeof OnboardingMarketingRoute
  OnboardingStripeRoute: typeof OnboardingStripeRoute
  OnboardingTermsRoute: typeof OnboardingTermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/terms': {
      id: '/onboarding/terms'
      path: '/onboarding/terms'
      fullPath: '/onboarding/terms'
      preLoaderRoute: typeof OnboardingTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/stripe': {
      id: '/onboarding/stripe'
      path: '/onboarding/stripe'
      fullPath: '/onboarding/stripe'
      preLoaderRoute: typeof OnboardingStripeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/marketing': {
      id: '/onboarding/marketing'
      path: '/onboarding/marketing'
      fullPath: '/onboarding/marketing'
      preLoaderRoute: typeof OnboardingMarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/gpi': {
      id: '/onboarding/gpi'
      path: '/onboarding/gpi'
      fullPath: '/onboarding/gpi'
      preLoaderRoute: typeof OnboardingGpiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/payments': {
      id: '/history/payments'
      path: '/payments'
      fullPath: '/history/payments'
      preLoaderRoute: typeof HistoryPaymentsRouteImport
      parentRoute: typeof HistoryRouteRoute
    }
    '/history/patients': {
      id: '/history/patients'
      path: '/patients'
      fullPath: '/history/patients'
      preLoaderRoute: typeof HistoryPatientsRouteImport
      parentRoute: typeof HistoryRouteRoute
    }
    '/history/bulk-request': {
      id: '/history/bulk-request'
      path: '/bulk-request'
      fullPath: '/history/bulk-request'
      preLoaderRoute: typeof HistoryBulkRequestRouteImport
      parentRoute: typeof HistoryRouteRoute
    }
  }
}

interface HistoryRouteRouteChildren {
  HistoryBulkRequestRoute: typeof HistoryBulkRequestRoute
  HistoryPatientsRoute: typeof HistoryPatientsRoute
  HistoryPaymentsRoute: typeof HistoryPaymentsRoute
}

const HistoryRouteRouteChildren: HistoryRouteRouteChildren = {
  HistoryBulkRequestRoute: HistoryBulkRequestRoute,
  HistoryPatientsRoute: HistoryPatientsRoute,
  HistoryPaymentsRoute: HistoryPaymentsRoute,
}

const HistoryRouteRouteWithChildren = HistoryRouteRoute._addFileChildren(
  HistoryRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HistoryRouteRoute: HistoryRouteRouteWithChildren,
  OnboardingGpiRoute: OnboardingGpiRoute,
  OnboardingMarketingRoute: OnboardingMarketingRoute,
  OnboardingStripeRoute: OnboardingStripeRoute,
  OnboardingTermsRoute: OnboardingTermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
